export const updateUserLanguage = `
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      languageCode 
    }
  }
`;
